export const modelSlice = (set) => ({
  modelVerification: null,

  setModelVerification: (data) => {
    set({
      modelVerification: data,
    });
  },
});
